import React, { useEffect, useState } from 'react';
import { ConfirmSheet } from '$shared/components';
import { useTranslator } from '$hooks';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';

export const ConfirmCode = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [confirmCode, setConfirmCode] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const showConfirmCode = () => {
      dispatch(toastActions.hideToast());
      setIsVisible(true);
    };

    addEventListener('showConfirmCode', showConfirmCode);

    return () => {
      removeEventListener('showConfirmCode', showConfirmCode);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) {
      setConfirmCode('');
    }
  }, [isVisible]);

  const handleSubmit = (confirmCode: string) => {
    setIsVisible(false);

    if (confirmCode) {
      dispatchEvent(
        new CustomEvent('confirmCodeSubmit', {
          detail: {
            confirmCode,
          },
        }),
      );
    } else {
      dispatchEvent(new CustomEvent('confirmCodeReject'));
    }
  };

  const handleClose = () => {
    dispatchEvent(new CustomEvent('confirmCodeReject'));
    setIsVisible(false);
  };

  return (
    <ConfirmSheet
      title={t('confirm_code_title')}
      description={t('confirm_code_description')}
      placeholder={t('confirm_code_input_placeholder')}
      onSubmit={() => handleSubmit(confirmCode)}
      onClose={handleClose}
      mode="input"
      value={confirmCode}
      onChange={setConfirmCode}
      isOpened={isVisible}
    />
  );
};
